import { render } from "./Careers.vue?vue&type=template&id=96539a0c&scoped=true"
import script from "./Careers.vue?vue&type=script&lang=js"
export * from "./Careers.vue?vue&type=script&lang=js"

import "./Careers.vue?vue&type=style&index=0&id=96539a0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96539a0c"]])

export default __exports__